import { render } from "./AdSecure.vue?vue&type=template&id=2a2fe4fd&ts=true&lang=pug"
import script from "./AdSecure.vue?vue&type=script&lang=ts"
export * from "./AdSecure.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__